import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageShell } from "@/components/marketing/PageShell";
import { ARTICLES, findArticle } from "@/data/blog";
import NotFound from "@/pages/NotFound";

const Related = ({ current }) => {
  const picks = ARTICLES.filter((a) => a.slug !== current.slug && a.category === current.category).slice(0, 2);
  const list = [...picks, ...ARTICLES.filter((a) => a.slug !== current.slug && !picks.includes(a))].slice(0, 2);
  return (
    <div className="mt-10 grid gap-4 sm:grid-cols-2" data-testid="blog-related">
      {list.map((a) => (
        <Link key={a.slug} to={`/blog/${a.slug}`} className="group flex gap-4 rounded-2xl border border-gray-200 bg-white p-3 transition-colors hover:border-gray-400" data-testid={`blog-related-${a.slug}`}>
          <img src={a.image} alt="" className="h-20 w-24 shrink-0 rounded-xl object-cover" loading="lazy" />
          <div><span className="font-mono-label text-[9px] text-oath-accent">{a.category.toUpperCase()}</span><div className="mt-1 text-sm font-semibold leading-snug text-oath-ink group-hover:underline">{a.title}</div></div>
        </Link>
      ))}
    </div>
  );
};

export default function BlogPost() {
  const { slug } = useParams();
  const a = findArticle(slug);
  if (!a) return <NotFound />;
  return (
    <PageShell>
      <article className="mx-auto max-w-3xl" data-testid="blog-article">
        <Link to="/blog" className="inline-flex items-center gap-1 font-mono-label text-[10px] font-semibold text-oath-secondary hover:text-oath-ink" data-testid="blog-back"><ArrowLeft className="h-3.5 w-3.5" /> ALL ARTICLES</Link>
        <div className="mt-6 font-mono-label text-[10px] font-semibold text-oath-accent">{a.category.toUpperCase()}</div>
        <h1 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-oath-ink sm:text-4xl" data-testid="blog-title">{a.title}</h1>
        <img src={a.image} alt="" className="mt-8 h-64 w-full rounded-3xl object-cover sm:h-96" data-testid="blog-hero-image" />
        <p className="mt-8 text-lg leading-relaxed text-oath-ink">{a.intro}</p>
        {a.sections.map((s) => (
          <section key={s.h} className="mt-8">
            <h2 className="font-display text-xl font-bold text-oath-ink">{s.h}</h2>
            {s.p.map((p) => <p key={p.slice(0, 24)} className="mt-3 leading-relaxed text-oath-secondary">{p}</p>)}
          </section>
        ))}
        <div className="mt-12 flex flex-col gap-4 rounded-3xl bg-oath-navy p-8 text-white sm:flex-row sm:items-center sm:justify-between">
          <div><div className="font-display text-lg font-bold">Verify addresses with evidence, not assumptions.</div><p className="mt-1 text-sm text-white/60">Consent-first, reproducible verification for your team.</p></div>
          <Link to="/pricing" className="shrink-0 rounded-full bg-white px-6 py-3 text-center font-mono-label text-[11px] font-semibold text-oath-ink hover:bg-gray-100" data-testid="blog-cta-pricing">SEE PRICING</Link>
        </div>
        <Related current={a} />
      </article>
    </PageShell>
  );
}
